import DialogView from "../../dialog/Dialog.view.tsx";
import type UserDialogProperties from "../UserDialog.properties.ts";
import { useTranslation } from "react-i18next";
import styles from "./UserDialog.desktop.module.css";
import React from "react";
import InputView from "../../../components/input/Input.view.tsx";
import { useUserDialogController } from "../UserDialog.controller.ts";
import SmartSelectView from "../../../components/smart-select/SmartSelect.view.tsx";
import MultiSelectView from "../../../components/multi-select/MultiSelect.view.tsx";
import LoaderView from "../../../components/loader/Loader.view.tsx";

export default function UserDialogDesktopView(props: UserDialogProperties) {
  const { t } = useTranslation();
  const {
    handleSave,
    username,
    setUsername,
    firstname,
    setFirstname,
    lastname,
    setLastname,
    email,
    setEmail,
    password,
    setPassword,
    repeatPassword,
    setRepeatPassword,
    languageCode,
    roles,
    handleLanguageCodeChange,
    handleRolesChange,
    prepareLanguageCodeForSmartSelect,
    prepareRolesForSmartSelect,
    enableSaveButton,
    loading,
  } = useUserDialogController(props);

  return (
    <DialogView
      header={props.user ? t("ui.userEdit") : t("ui.userCreate")}
      onBackdrop={props.handleDialogCloseClick}
    >
      <div>
        <>
          {loading && <LoaderView />}

          {!loading && (
            <>
              <table className={styles.table}>
                <tbody>
                  <tr>
                    <td className={styles.tdKey}>
                      {t("table.userManagement.username")}
                    </td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        disabled={!!props.user}
                        width={248}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tdKey}>
                      {t("table.userManagement.firstname")}
                    </td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        width={248}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tdKey}>
                      {t("table.userManagement.lastname")}
                    </td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        width={248}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tdKey}>
                      {t("table.userManagement.email")}
                    </td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        width={248}
                      />
                    </td>
                  </tr>
                  {!props.user && (
                    <>
                      <tr>
                        <td className={styles.tdKey}>{t("ui.password")}</td>
                        <td className={styles.tdValue}>
                          <InputView
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type="password"
                            width={248}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className={styles.tdKey}>
                          {t("ui.repeatPassword")}
                        </td>
                        <td className={styles.tdValue}>
                          <InputView
                            value={repeatPassword}
                            onChange={(e) => setRepeatPassword(e.target.value)}
                            type="password"
                            width={248}
                          />
                        </td>
                      </tr>
                    </>
                  )}
                  <tr>
                    <td className={styles.tdKey}>
                      {t("table.userManagement.languageCode")}
                    </td>
                    <td className={styles.tdValue}>
                      <SmartSelectView
                        selectedValue={languageCode}
                        data={prepareLanguageCodeForSmartSelect()}
                        handleChange={handleLanguageCodeChange}
                        width="270px"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tdKey}>{t("ui.role")}</td>
                    <td className={styles.tdValue}>
                      <MultiSelectView
                        selectedValues={roles}
                        data={prepareRolesForSmartSelect()}
                        handleChange={handleRolesChange}
                        width="270px"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className={styles.buttonContainer}>
                <button
                  className={styles.buttonSave}
                  onClick={handleSave}
                  disabled={!enableSaveButton()}
                >
                  {t("ui.save")}
                </button>
              </div>
            </>
          )}
        </>
      </div>
    </DialogView>
  );
}
